export var FlowPrevisitFormSetStatus;
(function (FlowPrevisitFormSetStatus) {
    FlowPrevisitFormSetStatus["Created"] = "CREATED";
    FlowPrevisitFormSetStatus["MessageSent"] = "MESSAGE_SENT";
    FlowPrevisitFormSetStatus["MessageUndelivered"] = "MESSAGE_UNDELIVERED";
    FlowPrevisitFormSetStatus["MessageDelivered"] = "MESSAGE_DELIVERED";
    FlowPrevisitFormSetStatus["CannotReceiveNotification"] = "CANNOT_RECEIVE_NOTIFICATION";
    FlowPrevisitFormSetStatus["FormSetStarted"] = "FORM_SET_STARTED";
    FlowPrevisitFormSetStatus["FormSetCompleted"] = "FORM_SET_COMPLETED";
    FlowPrevisitFormSetStatus["FormSetExpired"] = "FORM_SET_EXPIRED";
})(FlowPrevisitFormSetStatus || (FlowPrevisitFormSetStatus = {}));
//# sourceMappingURL=status.js.map